export const getUser = state => state.clb.user

export const getUserEmail = state =>
    getUser(state) ? getUser(state).email : ''
